/* oxlint-disable */
/**
 * Match Hub/catalog gameCode against free_spins.games JSON (array, CSV, newlines, provider:code, -suffix).
 * Keep in sync with any server-side launch validation that uses the same rules.
 */

function expandGameIdVariants(raw: string): Set<string> {
  try {
    const s = String(raw).trim();
    const variants = new Set<string>();

    if (!s) {
      return variants;
    }

    const add = (v: string) => {
      const t = v.trim();
      if (t) {
        variants.add(t.toLowerCase());
      }
    };

    add(s);

    const firstLine = s.split(/\r?\n/)[0] ?? s;
    add(firstLine);

    const beforeHyphen = s.split('-')[0] ?? s;
    add(beforeHyphen);

    const firstLineBeforeHyphen = firstLine.split('-')[0] ?? firstLine;
    add(firstLineBeforeHyphen);

    if (s.includes(':')) {
      const afterColon = s.split(':').pop() ?? '';
      add(afterColon);

      const afterFirstLine = afterColon.split(/\r?\n/)[0] ?? afterColon;
      add(afterFirstLine);

      add((afterFirstLine.split('-')[0] ?? afterFirstLine).trim());
    }

    return variants;
  } catch (error) {
    console.warn('expandGameIdVariants error:', error);
    return new Set<string>();
  }
}

function collectStoredVariants(games: unknown): Set<string> {
  try {
    const all = new Set<string>();

    const absorb = (raw: string) => {
      expandGameIdVariants(raw).forEach((v) => {
        all.add(v);
      });
    };

    if (games == null) {
      return all;
    }

    if (Array.isArray(games)) {
      games.forEach((g) => {
        absorb(String(g));
      });
      return all;
    }

    if (typeof games === 'object') {
      Object.values(games as Record<string, unknown>).forEach((v) => {
        if (v == null) return;

        if (Array.isArray(v)) {
          v.forEach((x) => absorb(String(x)));
          return;
        }

        if (typeof v === 'object') {
          return;
        }

        absorb(String(v));
      });

      return all;
    }

    const str = String(games);

    if (str.includes(',') || /\r?\n/.test(str)) {
      str.split(/[\n,]+/).forEach((part) => {
        absorb(part);
      });
    }

    absorb(str);

    return all;
  } catch (error) {
    console.warn('collectStoredVariants error:', error);
    return new Set<string>();
  }
}

const SUBSTRING_MIN_LEN = 10;

function setsIntersectBySubstring(wanted: Set<string>, stored: Set<string>): boolean {
  try {
    return Array.from(wanted).some((w) => {
      if (w.length < SUBSTRING_MIN_LEN) {
        return false;
      }

      return Array.from(stored).some((s) => {
        if (s.length < SUBSTRING_MIN_LEN) {
          return false;
        }

        return s.includes(w) || w.includes(s);
      });
    });
  } catch (error) {
    console.warn('setsIntersectBySubstring error:', error);
    return false;
  }
}

export function freeSpinGamesIncludeGame(games: unknown, gameCode: string): boolean {
  try {
    const wantedRaw = String(gameCode).trim();

    if (!wantedRaw) {
      return false;
    }

    const wanted = expandGameIdVariants(wantedRaw);
    const stored = collectStoredVariants(games);

    if (Array.from(wanted).some((w) => stored.has(w))) {
      return true;
    }

    return setsIntersectBySubstring(wanted, stored);
  } catch (error) {
    console.warn('freeSpinGamesIncludeGame error:', error);
    return false;
  }
}